import PropTypes from 'prop-types';
import React from 'react';

import VMScratchBlocks from '../../lib/blocks';

import styles from './examples-library.css';

const definedBlockTypes = new Set();

class ExamplesPreviewWorkspace extends React.Component {
    constructor (props) {
        super(props);
        this.setWorkspaceRef = this.setWorkspaceRef.bind(this);
    }
    componentDidMount () {
        this.ScratchBlocks = VMScratchBlocks(this.props.vm, false);
        this.ScratchBlocks.ScratchMsgs.setLocale(this.props.locale);
        this.defineExtensionBlocks();

        const oldDefaultToolbox = this.ScratchBlocks.Blocks.defaultToolbox;
        this.ScratchBlocks.Blocks.defaultToolbox = null;
        this.workspace = this.ScratchBlocks.inject(this.workspaceRef, {
            comments: false,
            collapse: false,
            media: this.props.mediaPath,
            readOnly: true,
            rtl: this.props.isRtl,
            scrollbars: true,
            sounds: false,
            toolbox: null,
            zoom: {
                controls: false,
                maxScale: 1.5,
                minScale: 0.45,
                startScale: 0.72,
                wheel: true
            }
        });
        this.ScratchBlocks.Blocks.defaultToolbox = oldDefaultToolbox;

        this.loadXml();
    }
    componentDidUpdate (prevProps) {
        if (this.props.locale !== prevProps.locale) {
            this.ScratchBlocks.ScratchMsgs.setLocale(this.props.locale);
        }
        if (this.props.xml !== prevProps.xml) {
            this.loadXml();
        }
    }
    componentWillUnmount () {
        if (this.workspace) {
            this.workspace.dispose();
        }
    }
    setWorkspaceRef (ref) {
        this.workspaceRef = ref;
    }
    defineExtensionBlocks () {
        const extensionCategories = this.props.vm.runtime._blockInfo || [];
        const blockJson = [];

        const rememberJson = json => {
            if (!json || !json.type || definedBlockTypes.has(json.type)) return;
            definedBlockTypes.add(json.type);
            blockJson.push(json);
        };

        extensionCategories.forEach(categoryInfo => {
            (categoryInfo.menus || []).forEach(menuInfo => rememberJson(menuInfo.json));
            (categoryInfo.blocks || []).forEach(blockInfo => rememberJson(blockInfo.json));
        });

        if (blockJson.length > 0) {
            this.ScratchBlocks.defineBlocksWithJsonArray(blockJson);
        }
    }
    loadXml () {
        if (!this.workspace || !this.props.xml) return;
        const dom = this.ScratchBlocks.Xml.textToDom(this.props.xml);
        this.ScratchBlocks.Xml.clearWorkspaceAndLoadFromXml(dom, this.workspace);
        this.workspace.clearUndo();

        setTimeout(() => {
            if (!this.workspace) return;
            if (typeof this.workspace.zoomToFit === 'function') {
                this.workspace.zoomToFit();
            }
            if (typeof this.workspace.scrollCenter === 'function') {
                this.workspace.scrollCenter();
            }
        }, 0);
    }
    render () {
        return (
            <div
                className={styles.previewWorkspace}
                ref={this.setWorkspaceRef}
            />
        );
    }
}

ExamplesPreviewWorkspace.propTypes = {
    isRtl: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    mediaPath: PropTypes.string.isRequired,
    vm: PropTypes.shape({
        runtime: PropTypes.object
    }).isRequired,
    xml: PropTypes.string.isRequired
};

export default ExamplesPreviewWorkspace;

